import { FC } from "react";
import { Button, ButtonProps } from "../ui/button";
import * as Icon from "../icons";
import { T } from "@tolgee/react";

export const BomPageExplainerTrigger: FC<ButtonProps> = ({ ...props }) => (
  <Button {...props}>
    <Icon.HelpCircle id="explainer-dialog-trigger" />
    <T keyName="explainer-dialog-trigger-button-text" />
  </Button>
);
